import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    async function submit(e) {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await login(email, password);
            nav("/", { replace: true });
        }
        catch (err) {
            setError(err.message === "invalid_credentials" ? "Wrong email or password." : "Login failed. Try again.");
        }
        finally {
            setLoading(false);
        }
    }
    return (_jsx("div", { className: "min-h-dvh grid place-items-center bg-paper px-5", children: _jsxs("form", { onSubmit: submit, className: "card w-full max-w-sm p-8 flex flex-col gap-4", children: [_jsxs("div", { className: "text-center", children: [_jsxs("div", { className: "font-display text-3xl text-ink", children: [_jsx("span", { className: "text-accent", children: "IELL" }), " Karaitivu"] }), _jsx("div", { className: "eyebrow mt-1", children: "Marksheet \u00B7 Sign in" })] }), _jsxs("label", { className: "flex flex-col gap-1 text-sm", children: [_jsx("span", { className: "text-slate2", children: "Email" }), _jsx("input", { className: "input", type: "email", autoComplete: "username", value: email, onChange: (e) => setEmail(e.target.value), required: true })] }), _jsxs("label", { className: "flex flex-col gap-1 text-sm", children: [_jsx("span", { className: "text-slate2", children: "Password" }), _jsx("input", { className: "input", type: "password", autoComplete: "current-password", value: password, onChange: (e) => setPassword(e.target.value), required: true })] }), error && _jsx("p", { className: "text-danger text-sm", children: error }), _jsx("button", { className: "btn justify-center", disabled: loading, children: loading ? "Signing in…" : "Sign in" }), _jsx("p", { className: "text-xs text-slate2 text-center", children: "Forgot your password? Ask an admin to reset it." })] }) }));
}
